<div style="padding-bottom: 15px">
  <label style="color: rgba(0, 0, 0, 0.54); font-size: 13px">Select Rule</label>
  <ejs-dropdownlist
    [dataSource]="datas"
    (change)="onChange($event)"
    [index]="index"
    [fields]="fields"
    popupHeight="200px"
  ></ejs-dropdownlist>
</div>

<ejs-recurrenceeditor
  #reccurenceComponent
  [value]="value"
></ejs-recurrenceeditor>
